import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, Dropdown } from 'react-bootstrap';
import s from './ContentPageList.css';
import messages from '../../../locale/messages';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from '../../Link/Link';
import { FaPencil, FaTrash, FaEye, FaPlus, FaGlobe, FaMobile } from 'react-icons/fa6';
// import addIcon from '../../../../public/Icons/addNewIcon.svg';
import { connect } from 'react-redux';
import { deleteContentPageDetails, updateContentPageStatus } from '../../../actions/siteadmin/contentPageAction';
import { toastr } from 'react-redux-toastr';
import Loader from '../../Common/Loader/Loader';
import moment from 'moment';
import { hasPlacement } from '../../../helpers/contentPagePlacement';

import { contentPageUploadDir, siteUrl } from '../../../config';

class ContentPageList extends React.Component {
	static propTypes = {
		title: PropTypes.string.isRequired,
		data: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.number,
			metaTitle: PropTypes.string,
			metaDescription: PropTypes.string,
			pageUrl: PropTypes.string,
			content: PropTypes.string
		})),
		metrics: PropTypes.arrayOf(PropTypes.shape({
			contentPageId: PropTypes.number,
			clickCount: PropTypes.number,
			uniqueUserCount: PropTypes.number,
			lastClickedAt: PropTypes.string
		})),
		metricsLoading: PropTypes.bool,
		metricsError: PropTypes.string,
		refetch: PropTypes.func
	};

	static defaultProps = {
		data: [],
		metrics: []
	};

	constructor(props) {
		super(props)
		this.state = {
			loading: false
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	async handleChange(id, status) {
		const { updateContentPageStatus, refetch } = this.props;
		const isEnable = status === 'true'; // Convert string to Boolean
		this.setState({ loading: true });
		await updateContentPageStatus(id, isEnable);
		if (refetch) {
			await refetch();
		}
		this.setState({ loading: false });
	}

	handleDelete(id) {
		const { deleteContentPageDetails, refetch } = this.props;
		toastr.confirm('Are you sure you want to delete this content page?', {
			onOk: async () => {
				this.setState({ loading: true });
				await deleteContentPageDetails(id);
				if (refetch) {
					await refetch();
				}
				this.setState({ loading: false });
			},
		});
	}

	render() {
		const { data, title, metrics, metricsLoading, metricsError } = this.props;
		const { formatMessage } = this.props.intl;

		const metricsById = {};
		(metrics || []).forEach((row) => { metricsById[row.contentPageId] = row; });

		return (
			<div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
				<div className={s.tabelExport}>
					<div className={cx(s.padding2, s.paddingTop2, s.displayInlineBlock, s.btnSection)}>
						<Link to={'/siteadmin/contentpage/add'} className={s.addlinkBtn}>
							<FaPlus className={cx('mr-2')} />
							<FormattedMessage {...messages.addPage} />
						</Link>
					</div>
				</div>
				{
					metricsError &&
					<div className={s.metricsBar}>
						<div className={s.metricsError}>Click metrics unavailable: {metricsError}</div>
					</div>
				}
				<div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
					<Table className={cx("table")}>
						<thead>
							<tr>
								<th scope="col"><FormattedMessage {...messages.id} /></th>
								{/* <th scope="col"><FormattedMessage {...messages.metaTitle} /></th> */}
								{/* <th scope="col"><FormattedMessage {...messages.metaDescriptionText} /></th> */}
								<th scope="col"><FormattedMessage {...messages.pageTitle} /></th>
								{/* <th scope="col"><FormattedMessage {...messages.pageUrl} /></th> */}
								<th scope="col"><FormattedMessage {...messages.contentPagePlacementLabel} /></th>
								<th scope="col"><FormattedMessage {...messages.status} /></th>
								<th scope="col">Start Date</th>
								<th scope="col">End Date</th>
								<th scope="col">Clicks</th>
								<th scope="col">Unique Readers</th>
								<th scope="col"><FormattedMessage {...messages.action} /></th>
							</tr>
						</thead>
						<tbody>
							{
								this.state.loading && (
									<tr>
										<td colSpan="9" className="text-center">
											<Loader show={this.state.loading} type="circle" />
										</td>
									</tr>
								)
							}
							{
								!this.state.loading && data && data.length > 0 && data.map((post, index) => {
									const isEnabled = post.isEnable === true || post.isEnable === "true";
									const metric = metricsById[post.id];
									const lastClickedAt = metric && metric.lastClickedAt
										? moment(metric.lastClickedAt).local().format('DD MMM YYYY HH:mm')
										: null;
									return (
										<tr key={index} className={cx({ [s.inactiveRow]: !isEnabled })}>
											<td data-label={formatMessage(messages.id)}>
												{/* {post && post.pageBanner} */}
												<img src={`${siteUrl}/api/${contentPageUploadDir}medium_${post.pageBanner}`} height={44} alt="post image" />
											</td>
											{/* <td data-label={formatMessage(messages.metaTitle)}>{item && item.metaTitle}</td> */}
											{/* <td data-label={formatMessage(messages.metaDescriptionText)}>{item && item.metaDescription}</td> */}
											<td data-label={formatMessage(messages.pageTitle)}>{post && post.pageTitle}</td>
											{/* <td data-label={formatMessage(messages.pageUrl)}>{item && item.pageUrl}</td> */}
											<td data-label={'Placement'}>
												{post && hasPlacement(post.placement, 'APP') &&
													<span className='mr-2'>
														<FaMobile className='mr-1' /> App
													</span>
												}
												{post && hasPlacement(post.placement, 'WEB') &&
													<span>
														<FaGlobe className='mr-1' /> Web
													</span>
												}
											</td>
											<td data-label={formatMessage(messages.status)}>
												<select
													name="isEnable"
													onChange={(e) => this.handleChange(post.id, e.target.value)}
													value={String(post.isEnable)}
													className={cx(s.selectInput, {
														[s.selectActive]: isEnabled,
														[s.selectInactive]: !isEnabled
													})}
												>
													<option value="true">{formatMessage(messages.active)}</option>
													<option value="false">{formatMessage(messages.inactive)}</option>
												</select>
											</td>
											<td>{post.startDate ? moment.utc(post.startDate).local().format('DD MMM YYYY HH:mm') : '-'}</td>
											<td>{post.endDate ? moment.utc(post.endDate).local().format('DD MMM YYYY HH:mm') : '-'}</td>
											<td
												data-label={'Clicks'}
												title={lastClickedAt ? `Last click: ${lastClickedAt}` : undefined}
											>
												{
													metricsLoading
														? <span className={s.metricMuted}>&hellip;</span>
														: metric
															? <span className={s.metricValue}>{metric.clickCount}</span>
															: <span className={s.metricMuted}>0</span>
												}
											</td>
											<td data-label={'Unique Readers'}>
												{
													metricsLoading
														? <span className={s.metricMuted}>&hellip;</span>
														: metric
															? <span className={s.metricValue}>{metric.uniqueUserCount}</span>
															: <span className={s.metricMuted}>0</span>
												}
											</td>
											<td data-label={formatMessage(messages.action)} className={s.minWidth}>
												<Dropdown>
													<Dropdown.Toggle variant="light" size="sm" id={`dropdown-action-${post.id}`}>
														<FaPencil className={cx(s.editIcon, 'editIconRTL')} />
														<span className={s.vtrMiddle}>
															<FormattedMessage {...messages.editAction} />
														</span>
													</Dropdown.Toggle>
													<Dropdown.Menu>
														<Dropdown.Item href={`/page/${post.pageUrl}`} target="_blank">
															<FaEye className={cx(s.editIcon, 'editIconRTL')} />
															<FormattedMessage {...messages.preview} />
														</Dropdown.Item>
														<Dropdown.Item as={Link} to={`/siteadmin/contentpage/edit/${post.id}`}>
															<FaPencil className={cx(s.editIcon, 'editIconRTL')} />
															<FormattedMessage {...messages.editAction} />
														</Dropdown.Item>
														<Dropdown.Item onClick={() => this.handleDelete(post.id)} className="text-danger">
															<FaTrash className={cx(s.editIcon, 'editIconRTL')} />
															<span className={s.vtrMiddle}>
																<FormattedMessage {...messages.deleteAction} />
															</span>
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</td>
										</tr>
									)
								})
							}
						</tbody>
					</Table>
				</div>
			</div>
		)
	}

}

const mapState = (state) => ({
});

const mapDispatch = {
	deleteContentPageDetails,
	updateContentPageStatus
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ContentPageList)));